import Tone from 'tone';
import {setMasterVolume} from 'actions/index.js';
import MasterChannel from './MasterChannel.js';
import MixEffects from './MixEffects.js';

// reponsible for splitting tracks to other channels
// if the user wishes to record into seperate tracks
// into ableton (via 64 channel soundflower)

const MAX_CHANNELS = 16;

/*
const nativeConnect = AudioNode.prototype.connect
AudioNode.prototype.connect = function(dstNode, inputNum, outputNum){
    if (dstNode instanceof Tone){
	Tone.connect(this, dstNode, inputNum, outputNum)
    } else {
	nativeConnect.call(this, dstNode, inputNum, outputNum)
    }
}
*/

class ChannelMixer {
    constructor(sequencerEngine) {
        this.sequencerEngine = sequencerEngine;
        this.isMulti = false;
        this.lazyConnections = [];
        this.ctxt = Tone.Master.context._context;
        if (this.ctxt.destination.maxChannelCount >= 2) {
            this.ctxt.destination.channelCount = this.ctxt.destination.maxChannelCount;
            this.ctxt.destination.channelCountMode = "explicit";
            this.ctxt.destination.channelInterpretation = "discrete";
        }
        this.masterChannel = new MasterChannel(sequencerEngine);
        this.stereoOnly = sequencerEngine.stereoOnly;

        this.maxChannel = 0;
        this.stereoConnected = true;
        this.masterChannel.connect(Tone.Master);

        this.outputConnections = [];
        
        /*
        if (!this.stereoOnly) {
            this.switchOutputs(true);
        }
        */

        // this.setupAudioWorklet();
    }

    get channelCount() {
        return this.multiMerger.numberOfInputs;;
    }

    updateChannelCount() {
        if (Tone.Master.context._context.destination.maxChannelCount >= 2) {
            this.ctxt.destination.channelCount = this.ctxt.destination.maxChannelCount;
            this.ctxt.destination.channelCountMode = "explicit";
            this.ctxt.destination.channelInterpretation = "discrete";
        }
    }

    connectMixEffects() {
        if (!this.mixEffects) {
            this.masterChannel.disconnect();
            this.mixEffects = new MixEffects(this.sequencerEngine, this.masterChannel.output, Tone.Master);
        }
    }

    dispose() {
        if (this.mixEffects) {
            this.mixEffects.dispose();
        }
        this.masterChannel.dispose();
        this.masterChannel = null;
    }

    setVolume(vol, time=0.05) {
        this.masterChannel.output.volume.exponentialRampToValueAtTime(vol, time);
        this.sequencerEngine.store.dispatch(setMasterVolume(this.sequencerEngine.getSequenceId(), vol));
    }

    numberOfChannels() {
        return this.stereoConnected ? 2 : this.ctxt.destination.channelCount;
    }

    disconnect(output, outputs) {
        output.disconnect();
    }

    switchChannelOutput(output, leftChannel, rightChannel) {
        if (this.stereoOnly ||
            leftChannel >= this.numberOfChannels() ||
            rightChannel >= this.numberOfChannels()) {
            return false;
        }
        let channelInfo = this.outputConnections.find(
            c => c.output === output);

        if (!channelInfo) {
            return false;
        }

        channelInfo.splitter.disconnect();
        channelInfo.splitter.connect(this.multiMerger, 0, leftChannel);
        if (rightChannel) {
            channelInfo.splitter.connect(this.multiMerger, 1, rightChannel);
        }

        return true;
    }

    // returns a list of channels used for the output
    connect(output, maxChannel=this.maxChannel) {
        // connect to basic stereo merger
        output.connect(this.masterChannel.input);

       if (!this.stereoOnly) {
           // now connect to fancy multi channel merger
           let func = () => {
               let splitter = Tone.Master.context.createChannelSplitter(2);
               output.connect(splitter);
               let leftChannel = (maxChannel ) % this.channelCount;
               let rightChannel = (maxChannel + 1) % this.channelCount;
               splitter.connect(this.multiMerger, 0, leftChannel);
               splitter.connect(this.multiMerger, 1, rightChannel);
               return {
                   splitter,
                   output,
                   leftChannel,
                   rightChannel
               };
           }

           if (this.isMulti) {
               this.outputConnections.push(func());
           } else {
               this.lazyConnections.push(func);
           }
        }

        let channels = [(maxChannel) % 32, (maxChannel + 1) % 32];
        // this.maxChannel = maxChannel + 2;
        return channels;
    }

    switchOutputs(isMulti=false) {
        this.isMulti = isMulti;
        if (isMulti) {
            if (!this.stereoOnly) {
                if (this.multiMerger === undefined) {
                    if (!this.stereoOnly) {
                        this.multiMerger = Tone.Master.context.createChannelMerger(32);
                    }
                }
                this.multiMerger.connect(Tone.Master);
                Tone.Master.channelCount = 32;
                this.lazyConnections.forEach(func => {
                    this.outputConnections.push(func());
                });
                this.lazyConnections = [];
            }
            if (this.stereoConnected) {
                this.masterChannel.disconnect(Tone.Master);
            }
        } else {
            this.masteerChannel.connect(Tone.Master);
            if (!this.stereoConnected) {
                if (!this.stereoOnly) {
                    this.multiMerger.disconnect(Tone.Master);
                }
            }
        }

        this.stereoConnected = !isMulti;
    }

    async setupAudioWorklet() {
        let context = Tone.Master.context._context;
        await context.audioWorklet.addModule('/bypass-processor.js');
        const bypasser = new AudioWorkletNode(context, 'bypass-processor');
        this.masterChannel.output.connect(bypasser);
        bypasser.connect(Tone.Master);
    }
}

export default ChannelMixer;
